import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { FHEContainer } from 'data/components';
import ProductDetail from './components/Product/ProductDetail';
import { getProductsDetails, refreshProductStatus } from '../../data/Products/actions';

class ProductsDetails extends Component {
    static propTypes = {
        getProductsDetails: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        productKey: PropTypes.string.isRequired,
        homeId: PropTypes.string.isRequired,
        productType: PropTypes.string.isRequired,
        productIdentifier: PropTypes.string.isRequired,
        fheCenter_mac: PropTypes.string,
        moduleType: PropTypes.string,
        refreshProductStatus: PropTypes.func.isRequired
    };

    static defaultProps = {
        fheCenter_mac: null,
        moduleType: null
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getProductsDetails();
    }

    getProductsDetails = () => {
        const { getProductsDetails, homeId, productType, productIdentifier } = this.props;
        this.setState({ loading: true, error: null });
        getProductsDetails(homeId, productType, productIdentifier)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    refreshStatusProduct = (productType, productMac) => {
        const { refreshProductStatus, fheCenter_mac, moduleType, history } = this.props;
        return refreshProductStatus(fheCenter_mac, productType, productMac, moduleType)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.table.action.refresh.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.products.table.action.refresh.error`)
                );
            });
    };
    renderChildren = () => {
        const { productKey, productType, moduleType } = this.props;

        return (
            <ProductDetail
                productKey={productKey}
                productType={productType}
                moduleType={moduleType}
                refreshStatusProduct={this.refreshStatusProduct}
            />
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getProductsDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { match, history } = props;
    const homeId = match.params.homeId;
    const productType = match.params.productType;
    const productIdentifier = match.params.productIdentifier;
    const productKey = `${homeId}_${productType}_${productIdentifier}`;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === product.get('homeId')) fheCenter_mac = macAddress;
    });
    return {
        profile: state.data.user,
        productKey,
        moduleType: product.get('type'),
        initialized: state.environments[history.environment].data.Products.get('initialized'),
        fheCenter_mac,
        homeId,
        productType,
        productIdentifier
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Products/details',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getProductsDetails, refreshProductStatus }), dispatch)
        )(ProductsDetails)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/details.js